export const state = {
  rapportActivite: undefined,
  rapportActivites: [],
  pagination: { size: 20 }
}